import React from "react";
import { SquareBanner } from "../../components/topbanner";

function HomePage() {
  return <SquareBanner />;
}

export default HomePage;
